import { inicialesDe } from "../utiles.ts";

/**
 * Columna "Lectura" del mockup (pantalla 01) y tarjeta "Acuses" de la 04: avatares apilados de
 * quienes ya dieron acuse, con `+N` de desbordamiento, y el "N de M" al lado.
 */
export function Lectores({
  lectura,
  maximo = 3,
  conTexto = true,
}: {
  lectura: { leidos: number; total: number; lectores: { nombre: string }[] };
  maximo?: number;
  conTexto?: boolean;
}) {
  if (lectura.total === 0) return <span className="text-texto-3">—</span>;
  const visibles = lectura.lectores.slice(0, maximo);
  const resto = lectura.lectores.length - visibles.length;
  const completo = lectura.leidos === lectura.total;
  return (
    <div className="flex items-center gap-2">
      {visibles.length > 0 && (
        <div className="flex -space-x-1.5">
          {visibles.map((l) => (
            <span
              key={l.nombre}
              title={l.nombre}
              className="grid size-6 place-items-center rounded-full bg-marino text-[9.5px] font-semibold text-white ring-2 ring-white"
            >
              {inicialesDe(l.nombre)}
            </span>
          ))}
          {resto > 0 && (
            <span className="grid size-6 place-items-center rounded-full bg-fondo text-[9.5px] font-semibold text-texto-2 ring-2 ring-white">
              +{resto}
            </span>
          )}
        </div>
      )}
      {conTexto && (
        <span
          className={`text-[11.5px] font-semibold whitespace-nowrap ${completo ? "text-verde" : "text-texto-3"}`}
        >
          {lectura.leidos} de {lectura.total}
        </span>
      )}
    </div>
  );
}
